import React from 'react';
import Image from 'next/image';
import Button from '@mui/material/Button';
import { Input } from '@/components/form';
import UniversalModal from '@/components/modal/UniversalModal';
import SuccessModal from '@/components/subscribe-job/SuccessModal';
import SubscribeModal from '@/components/subscribe-job/SubscribeModal';
import { CityOption } from '@/context/city';
import { INPUT_TYPE_EMAIL } from '@/components/subscribe-job';
import { JobOptionType } from '@/components/job-title/search-area/JobTitleSearch';
import { useDebounce } from '@/utils/hooks';
import validators from '@/utils/validators';
import FormValidator from '@/utils/form-validator';
import emailIcon from '@/assets/job-title/email.png';

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  jobValue: JobOptionType;
  city?: CityOption;
};

const VALIDATOR_MAP = {
  [INPUT_TYPE_EMAIL]: [
    validators.valueRequired('请输入你的邮箱'),
    validators.email(),
  ],
};

type FieldType = Record<string, string>;

const formValidator = new FormValidator(VALIDATOR_MAP);

const SubscribeEmailModal = (props: Props) => {
  const { open, setOpen, jobValue, city } = props;
  const [email, setEmail] = React.useState('');
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [error, setError] = React.useState<FieldType>({});
  const handleError = (errorMsgs: FieldType) => {
    setError(errorMsgs);
  };

  const handleValidate = (value: string) => {
    formValidator.validate({ [INPUT_TYPE_EMAIL]: value });
    const error = formValidator.getError();
    error && handleError(error as FieldType);
    return formValidator.isOk();
  };

  const handleEmailValidate = useDebounce((value) => {
    handleValidate(value);
  });

  const handleChange = (val: string) => {
    setEmail(val);
    handleEmailValidate(null, val);
  };

  const handleClick = () => {
    const isOk = handleValidate(email);
    if (isOk && jobValue.id) {
      setOpen(false);
      setConfirmOpen(true);
    }
  };

  const handleSuccess = () => {
    setSuccessOpen(true);
  };

  const handleClose = () => {
    setConfirmOpen(false);
  };

  React.useEffect(() => {
    if (open) {
      setError({});
      setEmail('');
    }
  }, [open]);

  return (
    <>
      <UniversalModal
        open={open}
        onClose={() => setOpen(false)}
        title={<></>}
        headerHeight={76}
        headerBorder=""
        headerClass="font-semibold"
        width={418}
        maxWidth={false}
        footer={<></>}
        fullScreen={false}
      >
        <div className="p-10 pt-0 tablet:p-20 tablet:pt-3">
          <Image alt="" src={emailIcon} width={64} height={77} />
          <p className="mt-6 font-semibold text-xl">请输入你的订阅邮箱</p>
          <Input
            value={email}
            onChange={handleChange}
            error={!!error[INPUT_TYPE_EMAIL]}
            helperText={error[INPUT_TYPE_EMAIL]}
            placeholder="输入你的邮箱地址"
            className="py-6 flex-1"
            type={INPUT_TYPE_EMAIL}
          />
          <Button
            variant="contained"
            className="!w-full !h-12 !rounded-lg"
            onClick={handleClick}
          >
            订阅
          </Button>
          <p className="text-xs text-black/65 my-2 line-clamp-1">
            您可以在邮箱中随时取消订阅
          </p>
        </div>
      </UniversalModal>
      <SubscribeModal
        open={confirmOpen}
        email={email}
        city={city}
        jobValue={jobValue}
        handleSuccess={handleSuccess}
        handleClose={handleClose}
      />
      <SuccessModal open={successOpen} setOpen={setSuccessOpen} />
    </>
  );
};

export default SubscribeEmailModal;
